<template>
	<v-tabs
		class="type-active-jobs"
		v-model="selectedTabIndex"
		@input="handleTabClick">
		<v-tab
			v-for="(jobsType, index) in ASSIGN_TYPES" :key="index">
			<b>{{ jobsType.label }}</b>
		</v-tab>
	</v-tabs>
</template>

<script>
import { ASSIGN_TYPES } from '@/components/configuration/report-template/constant';

export default {
	name: 'selector-assign-template',
	data() {
		return {
			ASSIGN_TYPES,
			selectedTabIndex: 0,
		};
	},
	props: ['indexTab'],
	methods: {
		handleTabClick(index) {
			this.$emit('typeAssign', index);
		},
	},
	watch: {
		indexTab: {
			handler(newVal) {
				this.selectedTabIndex = newVal;
			},
		},
	},
};
</script>

<style lang="scss">
.type-active-jobs {
	.v-tabs__bar {
		background: transparent !important;

		.v-tabs__slider-wrapper {
			.accent {
				background: var(--app-color-primary) !important;
			}
		}

		.v-tabs__container {
			height: 30px !important;

			.v-tabs__div {
				color: var(--app-color-primary) !important;
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/configuration/report-template/selector-assign-template.vue